module.exports = __webpack_public_path__ + "static/media/Business vision-pana.b5557d18.png";